<link href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined" rel="stylesheet" />

<div class="container-fluid h-screen overflow-hidden">
    <div *ngIf="ViewPermission" class="grid grid-rows-2 mt-2 gap-2">
        <div class="grid grid-cols-7 h-80 gap-2 mt-2">
            <div class="col-span-1 bg-white border border-gray-200 rounded-2xl shadow-md overflow-y-auto">

                <!-- Header Label -->
                <div
                    class="flex items-center gap-2 px-4 py-3 border-b border-gray-200 bg-gray-200 rounded-t-2xl shadow-sm sticky top-0 z-10">
                    <span class="material-symbols-outlined text-[#4e54c8] text-2xl">groups</span>
                    <h2 class="text-lg font-semibold text-[#4e54c8] tracking-wide">Patients</h2>
                </div>

                <!-- Search Bar -->
                <div class="p-2 border-b border-gray-200 bg-white sticky top-[52px] z-10">
                    <input type="text" placeholder="Search" [(ngModel)]="searchString" (keyup)="filterPatient()"
                        class="input input-sm" />
                </div>

                <!-- User List -->
                <div class="flex-1 overflow-y-auto">
                    <ul>
                        <li *ngFor="let user of users; trackBy: trackByUser" (click)="selectChatUser(user)"
                            class="flex items-center gap-3 px-2 py-2 cursor-pointer transition-all duration-300 ease-in-out hover:bg-gray-100"
                            [ngClass]="{
              'border-l-4 border-[#4e54c8] bg-[#f0f2ff] rounded-r-md':
                selectedUser?.patientID === user.patientID
            }">

                            <div class="w-6 h-6 rounded-full flex items-center justify-center font-semibold text-white text-2xs shadow-sm"
                                [ngStyle]="{ 'background-color': '#4e54c8' }">
                                {{ user.firstName | initials:user.lastName }}
                            </div>

                            <div class="flex-1 overflow-hidden">
                                <p class="font-medium text-sm text-gray-800 truncate">
                                    {{ user.lastName }}, {{ user.firstName }}
                                </p>
                                <p class="text-xs text-gray-500 truncate">
                                    {{
                                    user.smsContactNumber ?? user.contactNumber ?? '-'
                                    }}
                                </p>
                            </div>

                            <span *ngIf="user.unreadMessages"
                                class="bg-blue-500 text-white text-xs px-2 py-1 rounded-full shadow-sm">
                                {{ user.unreadMessages }}
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- CHAT SECTION -->
            <div class="col-span-4 bg-white border border-gray-200 rounded-2xl shadow-md overflow-y-auto">
                <div class="flex-1 flex flex-col min-h-0">

                    <!-- Empty Chat -->
                    <div *ngIf="!selectedChatPatientId" class="flex-1 flex items-center justify-center p-6 mt-10">
                        <div class="text-center">
                            <div
                                class="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-[#f0f2ff]">
                                <span class="material-symbols-outlined text-[#4e54c8] text-4xl">chat_bubble</span>
                            </div>
                            <h2 class="text-lg font-semibold text-gray-800">
                                No messages yet!
                            </h2>
                            <p class="text-gray-500">Start a conversation now.</p>
                        </div>
                    </div>

                    <!-- Active Chat -->
                    <div *ngIf="selectedChatPatientId" class="flex-1 flex flex-col min-h-0">
                        <div class="text-right p-3 sticky top-0 bg-white z-10 border-b border-gray-200">
                            <a [href]="'/home/patients/profile/patient-data/' + selectedChatPatientId" target="_blank"
                                class="inline-flex items-center gap-2 px-2 py-2 rounded-full bg-gradient-to-r from-[#4e54c8] to-[#3f448f] text-white text-sm font-semibold shadow hover:shadow-md transition-all">
                                <span class="material-symbols-outlined text-sm text-white">person</span>
                                Visit Profile
                                <span class="material-symbols-outlined text-white text-sm">arrow_forward</span>
                            </a>
                        </div>

                        <!-- Messages Area -->
                        <div class="flex-1 overflow-y-auto pb-3">
                            <app-patient-chat [PatientID]="selectedChatPatientId"
                                [styleString]="'width: 100%; height: 45vh;'">
                            </app-patient-chat>
                        </div>
                    </div>
                </div>  
            </div>
            <!-- RIGHT PANEL -->
            <div class="col-span-2 bg-white border border-gray-200 rounded-2xl shadow-md overflow-y-auto">
                <div class="flex border-b border-gray-200 sticky top-0 bg-white z-10">
                    <button *ngFor="let tab of ['appointment-reminders','payment-notifications']; trackBy: trackByIndex"
                        (click)="activeRightTab = tab"
                        class="flex-1 py-3 text-sm font-medium transition-all flex items-center justify-center gap-2"
                        [ngClass]="{
              'text-[#4e54c8] border-b-2 border-[#4e54c8]':
                activeRightTab === tab,
              'text-gray-500 hover:text-[#4e54c8]': activeRightTab !== tab
            }">
                        <span class="material-symbols-outlined text-base">
                            {{ tab === 'appointment-reminders' ? 'event' : 'payments' }}
                        </span>
                        <span class="whitespace-nowrap">
                            {{ tab === 'appointment-reminders' ? 'Reminders' : 'Payments' }}
                        </span>
                    </button>
                </div>

                <div class="overflow-y-auto p-4">

                    <!-- Appointment Reminders -->
                    <div *ngIf="activeRightTab === 'appointment-reminders'">
                        <h3 class="text-md font-semibold mb-3 text-gray-800">
                            Appointment Reminders
                        </h3>

                        <ng-container *ngIf="appointmentReminders?.length > 0; else noReminders">
                            <div *ngFor="let reminder of appointmentReminders; trackBy: trackById"
                                class="mb-4 p-4 rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition">
                                <p class="font-medium text-gray-800">
                                    Patient: {{ reminder.patient }}
                                </p>
                                <p class="text-gray-600 text-nowrap text-sm">
                                    Appointment Date: {{ reminder.appointmentDate }}
                                </p>
                                <p class="text-gray-600 text-sm">
                                    Reminder Date: {{ reminder.reminderDate }}
                                </p>
                            </div>
                        </ng-container>

                        <ng-template #noReminders>
                            <p class="text-center text-gray-500 text-sm mt-20">No appointment reminders found.</p>
                        </ng-template>
                    </div>

                    <!-- Payment Notifications -->
                    <div *ngIf="activeRightTab === 'payment-notifications'">
                        <h3 class="text-md font-semibold mb-3 text-gray-800">
                            Payment Notifications
                        </h3>

                        <ng-container *ngIf="paymentNotifications?.length > 0; else noPayments">
                            <div *ngFor="let payment of paymentNotifications | slice:0:10; trackBy: trackById"
                                class="mb-4 p-4 rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition">
                                <p class="font-medium text-gray-800">
                                    Patient: {{ payment.patient }}
                                </p>
                                <p class="text-gray-600 text-sm">
                                    Amount: ${{ payment.amount }}
                                </p>
                                <p class="text-gray-600 text-sm">
                                    Date: {{ payment.date | date:'MMM d, yyyy – h:mm a' }}
                                </p>
                                <p class="text-gray-600 text-sm">
                                    Mode: {{ payment.paymentMode }}
                                </p>
                            </div>
                        </ng-container>

                        <ng-template #noPayments>
                            <p class="text-center text-gray-500 text-sm mt-20">
                                No payment notifications available.
                            </p>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>

        <!-- MAIL SECTION -->
        <div class="h-full">
            <section class=" bg-white border border-gray-200 rounded-2xl shadow-md overflow-y-auto h-full">
                <div
                    class="flex items-center justify-between text-sm font-semibold px-5 py-2.5 bg-gray-200 border-b border-gray-200">
                    <div class="flex items-center gap-2">
                        <span class="material-symbols-outlined text-[#4e54c8] text-2xl">mail</span>
                        <span class="text-[#4e54c8] text-lg font-bold">Mail</span>
                    </div>
                </div>

                <div *ngIf="patientMails?.length > 0; else noMail" class="h-72 min-h-72 overflow-y-auto pr-2">
                    <div *ngFor="let mail of patientMails; trackBy: trackByEmailLog"
                        class="mb-4 p-4 border border-gray-200 shadow-sm hover:shadow-md transition">
                        <p class="font-medium text-gray-800">{{ mail.emailSubject }}</p>
                        <div class="text-gray-600 text-sm mt-1" [innerHTML]="mail.emailBody"></div>
                        <p class="text-xs text-gray-400 mt-2">
                            📅 {{ mail.queuedTime | date: 'medium' }}
                        </p>
                    </div>
                </div>

                <ng-template #noMail>
                    <div class="h-72 min-h-72 overflow-y-auto pr-2">
                        <p class="text-center text-gray-500" style="margin-top: 140px;">No mails available.</p>
                    </div>
                </ng-template>
            </section>
        </div>
    </div>
</div>
<!-- MAIN TOP CONTENT -->